// extracted by mini-css-extract-plugin
export default {"svg":"svg--TTYeM","outlineNone":"outlineNone--xoP78"};